import React, {useState} from "react";
import { connect } from "react-redux";
import { useRecoilValue } from "recoil";
import find from "lodash/find";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import { gameTemplateListState } from "state/gameTemplatesState";
import AccessDenied from "components/common/AccessDenied";
import AdminBase from "components/layout/AdminBase";
import AdminGameTemplateFormContainer from "components/admin/forms/AdminGameTemplateFormContainer";
import Modal from "components/common/Modal";
import SortableDataTable from "components/common/SortableDataTable";
import * as UserPermissions from "constants/UserPermissions";
import {getNameForGameComparisonPeriod} from "utils/GamesUtils";
import { PermissionTypes, userHasPermission } from "utils/permissions/rolesPermissions";

function AdminGameTemplatesPage(props) {
	const templates = useRecoilValue(gameTemplateListState);
    const [templateId, setTemplateId] = useState(null);
    const selectedTemplate = find(templates, { greenlineGameTemplateId: templateId });

    const handleClicked = (gameTemplate) => {
        setTemplateId(gameTemplate.greenlineGameTemplateId);
    };

	const COLUMNS = [{
        key: "name",
        name: "Name",
        searchable: true,
        selector: "name",
        format: row => <div>{row.config?.GameNameLocked && <i className="fa fa-lock" />} {row.name}</div>
    }, {
        key: "gameType",
        name: "Type",
        selector: "gameType",
        format: row => <div className="no-wrap">{row.config?.GameTypeLocked && <i className="fa fa-lock" />} {row.gameType}</div>
    }, {
        key: "gameTypeVersion",
        name: "Type Version",
        selector: "gameTypeVersion",
    }, {
        key: "comparisonPeriod",
        name: "Comparison Period",
        selector: "comparisonPeriod",
        format: row => <div>{row.config?.ComparisonPeriodLocked && <i className="fa fa-lock" />} {getNameForGameComparisonPeriod(row.comparisonPeriod)}</div>
    }, {
        key: "durationDays",
        name: "Duration",
        selector: "durationDays",
		format: row => (
			<div className="no-wrap">{row.config?.DurationDaysLocked && <i className="fa fa-lock" />} {row.durationDays} days</div>
		),
    }, {
        key: "startDateMoment",
        name: "Start Date",
        selector: "startDateMoment",
		format: row => (
			<div className="no-wrap">{row.config?.StartDateLocked && <i className="fa fa-lock" />} {row.startDateMoment ? row.startDateMoment.format("MM/DD/YYYY") : null}</div>
		),
    }, {
        key: "config?.MaxClinics",
        name: <div className="text-center">Max <br />Clinics</div>,
        selector: "config?.MaxClinics",
        format: row => <div className="text-center">{row.config?.MaxClinics}</div>
    }, {
        key: "products",
        name: "Product Brands",
        selector: "products",
        format: row => <div>{row.config?.ProductBrandsLocked && <i className="fa fa-lock" />} {map(row.products, (product, index) => <span>{index > 0 && ", "}{product.productBrandId}</span>)}</div>,
    }, {
        key: "config?.ExcludeFreeDosesLocked",
        name: <div className="text-center">Exclude <br />Free <br />Doses</div>,
        selector: "config?.ExcludeFreeDosesLocked",
        format: row => row.config?.ExcludeFreeDosesLocked && <div className="text-center"><i className="fa fa-lock" /></div>,
    }];

    const handleClose = () => {
        setTemplateId(null);
    };

    return (
        <AdminBase
            collapsible
	        hasGreenBackground
            pageTitle="Game Template Management"
        >
	        {props.canEditGamesAdmin ? (
                <>
                    <SortableDataTable
                        green
                        striped
                        columns={COLUMNS}
                        rawData={orderBy(templates, ["config.startDateLocked", "startDateMoment", "name"], ["asc", "desc", "asc"])}
                        onClick={handleClicked}
                    />
                    <Modal
                        large
                        modalTitle={selectedTemplate?.name || ""}
                        onClose={handleClose}
                        show={!!templateId}
                    >
                        {templateId && (
                            <AdminGameTemplateFormContainer
                                initialData={selectedTemplate}
                                onClose={handleClose}
                            />
                        )}
                    </Modal>
                </>
	        ) : (
				<AccessDenied />
	        )}
        </AdminBase>
    )
}

export default connect(
    (state) => {
        const userProfile = state.user.userProfile;
	    const canEditGamesAdmin = userHasPermission(PermissionTypes.EDIT, UserPermissions.GAMES_ADMIN, userProfile);

        return {
            canEditGamesAdmin,
        }
    },
)(AdminGameTemplatesPage);
